<template>
	<div>
		<div class="view-framework">
			<userLeft></userLeft>
			<div class="view-framework-body">
				<div class="view-framework-main">
					<div class="tabnavs">
						<el-tabs v-model="activeName"  @tab-click="handleClick">
							<el-tab-pane label="基本资料" name="/setting"></el-tab-pane>
							<el-tab-pane label="实名认证" name="/real"></el-tab-pane>
							<el-tab-pane label="密码管理" name="/passWord"></el-tab-pane>
							<el-tab-pane label="手机设置" v-if="userList.phone" name="/updatePhone"></el-tab-pane>
							<el-tab-pane label="绑定手机" v-if="!userList.phone" name="/bindPhone"></el-tab-pane>
							<el-tab-pane label="提现账号" name="/withdrawAccount"></el-tab-pane>
						</el-tabs>
					</div>

					<div class="box tab-content realname-content">
						<div class="status-hint"  v-if="isHigh&&is_real">
							<div class="status-hint-icon">
								<i class="iconimg iconimg-realname-succeed"></i>
							</div>
							<div class="status-hint-text">
								<h3>
									{{nameList.name}}
									<span class="label label-primary">已实名认证</span>
								</h3>
								<p>证件类型：身份证</p>
								<p>证件号码：{{md5Number(nameList.id_number)}}</p>
								<p>认证渠道：{{nameList.mode}}</p>
								<p>认证日期：{{nameList.create_time}}</p>
							</div>
						</div>
						<div class="userform userform-narrow" v-if="!isHigh||!is_real">
							<div class="form-group mb20">
								<label class="form-label">&nbsp;</label>
								<div class="form-element">
									<ul class="btn-group btn-group-long clearfix">
										<li  :class="{active:type===1}" @click="realType(1)">
											<a class="btn">
												初级实名认证
											</a>
										</li>
										<li class="divider">
											<span class="sep">和</span>
										</li>
										<li class="" :class="{active:type===2}" @click="realType(2)">
											<a class="btn">
												高级实名认证
											</a>
										</li>
									</ul>
								</div>
							</div>
							<div v-if="type === 1">
								<div class="form-group">
									<label class="form-label">
										<em>*</em>
										真实姓名
									</label>
									<div class="form-element">
										<input  v-model="name" class="form-control form-control-short" type="text" placeholder="请输入真实姓名"/>
										<div class="form-tips">
											<p>请输入与身份证一致的真实姓名</p>
										</div>
									</div>
								</div>
								<div class="form-group">
									<label class="form-label">
										<em>*</em>
										 身份证号码：
									</label>
									<div class="form-element">
										<input v-model="nameID" class="form-control" type="text" placeholder="请输入身份证号"/>
										<div class="help-block">
											<p>请输入与身份证一致身份证号</p>
										</div>
									</div>
								</div>
								<div class="realname-tabs">
									<div class="form-group-btn pt10 clearfix">
										<button class="btn btn-green make-alipay pull-left" type="button" @click="postRealc()">提交</button>
									</div>
								</div>
							</div>
							<div class="" v-if="type===2">
								<div class="form-group">
									<label class="form-label">
										真实姓名
									</label>
									<div class="form-element">
										<input  v-model="is_name" disabled class="form-control form-control-short" type="text" placeholder="请输入真实姓名"/>
										<div class="form-tips">
											<p>请输入与身份证一致的真实姓名</p>
										</div>
									</div>
								</div>
								<div class="form-group">
									<label class="form-label">
										 身份证号码：
									</label>
									<div class="form-element">
										<input v-model="is_number" disabled class="form-control" type="text" placeholder="请输入身份证号"/>
										<div class="help-block">
											<p>请输入与身份证一致身份证号</p>
										</div>
									</div>
								</div>
								<div class="form-group">
									<label class="form-label">
										 认证方式：
									</label>
									<div class="form-element">
										  <el-select v-model="value" placeholder="请选择">
										    <el-option
										      v-for="item in options"
										      :key="item.value"
										      :label="item.label"
										      :value="item.value">
										    </el-option>
										  </el-select>
									</div>
								</div>
								<div class="realname-tabs">
									<div class="form-group-btn pt10 clearfix">
										<button class="btn btn-green make-alipay pull-left" type="button" @click="getIsReal">前往认证</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<el-dialog
			  title="提示"
			  :visible.sync="dialogVisible"
			  width="40%"
			  >
				<div class=" text-center">
					<p class="text-red">{{value === 1?"请使用支付宝扫描下方二维码，完成高级实名认证后请刷新当前页面":"请使用微信扫描下方二维码，完成高级实名认证后请刷新当前页面"}}</p>
					<img class="gaojiewm"  :src="image"/>
				</div>
			</el-dialog>
		</div>
	</div>
</template>

<script>
  import config from '@/config'
	export default{
		data(){
			return{
				activeName:"",
				userList:[],
				type:1,
				isHigh:false,
				is_real:false,
				name:"",
				nameID:"",
				is_name:"",
				is_number:"",
				options: [{
					value: 1,
					label: '支付宝高级实名认证'
				}, {
					value: 2,
					label: '微信高级实名认证'
				}],
				nameList:[],
				value: 1,
				image:"",
				dialogVisible: false,
				baseUrl:""
			}
		},
		created(){
      this.baseUrl = config.apiUrl
			this.activeName =  window.location.hash.replace(/[#]/g, '')
			this.userList = JSON.parse(localStorage.getItem('userInfo'))
			this.loadDetail1()
		},
		methods:{
			md5Number(str){
				return str.substring(0,5) + '**********' + str.substring(12)
			},
			getIsReal(){

				if(this.value === 1){
					this.zfbHigh()
				}else{
					this.wxHigh()
				}
			},
			wxHigh(){
				const loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
				});
				let token = localStorage.getItem('token')
				this.$api.wxAuthentication({
					token: token
				}).then(res => {
					if(res.code === 1){
						let url = res.data.url
						url = encodeURIComponent(url)
						this.$api.getJsonQrcode({
							data:url
						}).then(result => {
							let image = 'data:image/png;base64,' + result.data
							this.image = image
							loading.close();
							this.dialogVisible = true

						})
					}else{
						this.$message({
							message: res.msg,
							type: 'warning'
						});
					}

				})
			},
			zfbHigh(){
				const loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
				});
				let token = localStorage.getItem('token')
				this.$api.aliAuthentication({
					token: token,
				}).then(res => {
					if(res.code === 1){
						let url = this.baseUrl+"/api/user/startCertify?id="+res.data.id+"&wxapp_id=10005&token="+token
						url = encodeURIComponent(url)
						this.$api.getJsonQrcode({
							data:url
						}).then(result => {
							let image = 'data:image/png;base64,' + result.data
							this.image = image
							loading.close();
							this.dialogVisible = true

						})
					}else{
						this.$message({
							message: res.msg,
							type: 'warning'
						});
					}
				})
			},
			postRealc(){
				if(!this.name){
					this.$message({
						message: '请输入姓名',
						type: 'warning'
					});
					return
				}
				if(!this.nameID){
					this.$message({
						message: '请输入身份证号',
						type: 'warning'
					});
					return
				}
				let token = localStorage.getItem('token')
				this.$api.realUser({
					token: token,
					name: this.name,
					card:this.nameID
				}).then(res => {
					if(res.code == 1){
						this.$message({
							message: res.msg,
							type: 'success'
						});
						setTimeout(() => {
							window.location.reload();
						},500)
					}else{
						this.$message({
							message: res.msg,
							type: 'warning'
						});
					}
				})
			},
			loadDetail1(){
				let token = localStorage.getItem('token')
				this.$api.getUserRealStatus({
					token: token,
					type:1
				}).then(res => {
					if(res.code === 1){
						this.is_real = !!res.data.name
						if(!this.is_real){
							this.type = 1
						}else{
							this.is_name = res.data.name
							this.is_number =  res.data.id_number
							this.is_number =  this.is_number.substring(0,5) + '**********' + this.is_number.substring(12)
							this.type = 2
						}
						this.loadDetail2()
					}
				})
			},
			loadDetail2(){
				let token = localStorage.getItem('token')
				this.$api.getUserRealStatus({
					token: token,
					type:2
				}).then(res => {
					if(res.code === 1){
						this.isHigh = !!res.data.name
						this.nameList = res.data

					}
				})
			},
			handleClick(tab, event) {
				this.$router.push({ path:this.activeName})
			},
			realType(index){
				if(index === 1){
					if(this.is_real){
						this.$message({
							message: '您已完成初级实名请高级实名',
							type: 'warning'
						});
					}
				}else{
					if(!this.is_real){
						this.$message({
							message: '请先完成初级实名',
							type: 'warning'
						});
					}
				}
			}
		}
	}
</script>

<style>
	.gaojiewm{
		width: 200px;
		height: 200px;
		/* margin-top: 50px; */
	}
</style>



// WEBPACK FOOTER //
// src/components/user/setting/real.vue